export default new Set([
	'Array',
	'Boolean',
	'console',
	'Date',
	'decodeURI',
	'decodeURIComponent',
	'encodeURI',
	'encodeURIComponent',
	'Infinity',
	'Intl',
	'isFinite',
	'isNaN',
	'JSON',
	'Map',
	'Math',
	'NaN',
	'Number',
	'Object',
	'parseFloat',
	'parseInt',
	'RegExp',
	'Set',
	'String',
	'undefined',
]);
